import { ApiButton, Icon } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import React from 'react';
import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  actionButton: {
    '& .MuiButton-label div': {
      maxWidth: 400,
    },
  },
  iconLabel: {
     ...typographyTheme(theme, 'h5'),
  },
}));

interface IDownloadSummaryPDFButton {
  onDownloadAction: () => void;
  isDownloading: boolean | undefined;
}

const DownloadSummaryPDFButton = ({
  isDownloading = false,
  onDownloadAction,
}: IDownloadSummaryPDFButton) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  if (isDownloading) {
    return <Icon name={IconName.loadingIndicator} size="L" color={theme.color.link.linkActive02} />;
  }
  return (
    <ApiButton
      className={classes.actionButton}
      variant="text"
      color="primary"
      status={isDownloading ? 'loading' : 'idle'}
      // @ts-ignore
      onClick={() => onDownloadAction()}
      id="link-download"
      size="small"
    >
      <IconWithLabel
        iconName={IconName.download}
        iconSize="M"
        label={t('exam->>RegistrationSummary.DownloadSummary')}
        typographyClassName={classes.iconLabel}
      />
    </ApiButton>
  );
};

export default DownloadSummaryPDFButton;
